import { Money, MoneyHand, TradeCheck } from '@carvana/helios-icons';
import {
  Background,
  ContentCenter,
  Header,
  Step,
  StepDescription,
  StepHeadline,
  StepIcon,
  StepsContainer,
  StepTitle
} from './Steps.styles';

const Steps = () => (
  <Background>
    <ContentCenter>
      <div>
        <Header>Sell or trade in just a few easy steps</Header>
        <StepsContainer>
          <Step>
            <StepHeadline>
              <StepIcon aria-label="money in hand icon">
                <MoneyHand size={32} />
              </StepIcon>
              <StepTitle>Get your offer</StepTitle>
            </StepHeadline>
            <StepDescription>
              Share a few vehicle details and we’ll extend a real offer in 2 minutes. No haggling.
              No hassles.
            </StepDescription>
          </Step>

          <Step>
            <StepHeadline>
              <StepIcon aria-label="trade vehicle icon">
                <TradeCheck size={32} />
              </StepIcon>
              <StepTitle>Trade-in or sell</StepTitle>
            </StepHeadline>
            <StepDescription>
              Trade in your old vehicle for a new one, or sell it to Carvana.
            </StepDescription>
          </Step>

          <Step>
            <StepHeadline>
              <StepIcon aria-label="money icon">
                <Money size={32} />
              </StepIcon>
              <StepTitle>Get paid</StepTitle>
            </StepHeadline>
            <StepDescription>
              We’ll do a quick, on-site review of your vehicle and pay you on the spot.
            </StepDescription>
          </Step>
        </StepsContainer>
      </div>
    </ContentCenter>
  </Background>
);

export default Steps;
